import {Directive, ElementRef, Input, OnInit} from '@angular/core';


@Directive({
  selector: '[lcmsAvatarPlaceHolder]',
  standalone : true
})
export class AvatarPlaceHolderDirective implements OnInit {
  @Input() src = '';

  constructor(private imageRef: ElementRef) {
  }

  ngOnInit(): void {
    const img = new Image();
    img.onload = () => {
      this.setImage(this.src);
    };

    img.onerror = () => {
      // Set a placeholder image
      this.setImage('./assets/passport/abstract-user-flat-1.svg');
    };

    img.src = this.src;
  }

  private setImage(src: string) {
    this.imageRef.nativeElement.setAttribute('src', src);
  }
}

